import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { message, Space, Button, Popconfirm } from 'antd';

import Client from 'containers/app/client';

const UserActions = ({ id, record }) => {
  const { disabled } = record || {};
  const [loading, setLoading] = useState(false);
  const text = disabled ? 'Enable account' : 'Disable account';

  const OnDisable = disabled
    ? async () => {
        setLoading(true);
        await Client.enableAccount(id);
        message.success('Account enabled');
        setLoading(false);
      }
    : async () => {
        setLoading(true);
        await Client.disableAccount(id);
        message.success('Account disabled');
        setLoading(false);
      };

  const OnDelete = async () => {
    setLoading(true);
    await Client.deleteAccount(id);
    message.success('Account deleted');
    setLoading(false);
  };

  const OnCancel = () => {
    message.error('Delete account canceled');
  };

  return (
    <Space size="middle">
      <Button loading={loading} disabled={loading} onClick={OnDisable}>
        {text}
      </Button>
      <Popconfirm
        title="Are you sure to delete this Account, this can not be undone?"
        description=""
        onConfirm={OnDelete}
        onCancel={OnCancel}
        okText="Yes"
        okButtonProps={loading}
        cancelText="No"
      >
        <Button danger loading={loading} disabled={loading}>
          Delete account
        </Button>
      </Popconfirm>
    </Space>
  );
};

UserActions.propTypes = {
  id: PropTypes.string.isRequired,
  record: PropTypes.shape({}),
};

UserActions.defaultProps = {
  record: {},
};

export default UserActions;
